import { MergedEmailChannel, MergedSmsSender } from '../types';

import { mockEmailChannel, mockMessageType } from './emailChannels';
import { mockSmsSender } from './smsSenders';

export * from './customMtaMobileApps';
export * from './espAccounts';
export * from './emailChannels';
export * from './smsSenders';
export * from './verificationProfiles';

export const mockMergedSmsSender: MergedSmsSender = {
  ...mockSmsSender,
  messageType: mockMessageType,
};

export const mockMergedEmailChannel: MergedEmailChannel = {
  ...mockEmailChannel,
  messageTypes: [mockMessageType],
};
